<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.33463 3.33203H11.668C14.8106 3.33203 16.382 3.33203 17.3583 4.30834C18.3346 5.28466 18.3346 6.856 18.3346 9.9987C18.3346 13.1414 18.3346 14.7128 17.3583 15.689C16.382 16.6654 14.8106 16.6654 11.668 16.6654H8.33463C5.19193 16.6654 3.62059 16.6654 2.64428 15.689C1.66797 14.7128 1.66797 13.1414 1.66797 9.9987C1.66797 6.856 1.66797 5.28466 2.64428 4.30834C3.62059 3.33203 5.19193 3.33203 8.33463 3.33203ZM11.043 7.4987C11.043 7.15352 11.3228 6.8737 11.668 6.8737H15.8346C16.1798 6.8737 16.4596 7.15352 16.4596 7.4987C16.4596 7.84387 16.1798 8.1237 15.8346 8.1237H11.668C11.3228 8.1237 11.043 7.84387 11.043 7.4987ZM11.8763 9.9987C11.8763 9.65353 12.1561 9.3737 12.5013 9.3737H15.8346C16.1798 9.3737 16.4596 9.65353 16.4596 9.9987C16.4596 10.3439 16.1798 10.6237 15.8346 10.6237H12.5013C12.1561 10.6237 11.8763 10.3439 11.8763 9.9987ZM12.7096 12.4987C12.7096 12.1535 12.9895 11.8737 13.3346 11.8737H15.8346C16.1798 11.8737 16.4596 12.1535 16.4596 12.4987C16.4596 12.8439 16.1798 13.1237 15.8346 13.1237H13.3346C12.9895 13.1237 12.7096 12.8439 12.7096 12.4987ZM9.16797 7.4987C9.16797 8.4192 8.4218 9.16536 7.5013 9.16536C6.58083 9.16536 5.83463 8.4192 5.83463 7.4987C5.83463 6.57822 6.58083 5.83203 7.5013 5.83203C8.4218 5.83203 9.16797 6.57822 9.16797 7.4987ZM7.5013 14.1654C10.8346 14.1654 10.8346 13.4192 10.8346 12.4987C10.8346 11.5782 9.34222 10.832 7.5013 10.832C5.66035 10.832 4.16797 11.5782 4.16797 12.4987C4.16797 13.4192 4.16797 14.1654 7.5013 14.1654Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'ConsultantsTamaIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>